import { List, ListItemButton, ListItemIcon, styled } from '@mui/material';
import { StyledListItemButtonProps, StyledListItemIconProps } from '../../props';

export const ListStyled = styled(List)(() => ({
  position: 'relative',
  paddingLeft: '12px',
  paddingRight: '12px',
  paddingTop: '12px',
  '& ::after': {
    content: "''",
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    width: 0,
    opacity: 0.2,
    backgroundColor: 'white',
  },
}));

export const StyledListItemIcon = styled(ListItemIcon, {
  shouldForwardProp: (prop) => !['level', 'isSideBarOpen', 'activeModule', 'iconSelectedColor'].includes(prop as string),
})<StyledListItemIconProps>(({ level, isSideBarOpen, activeModule, iconSelectedColor }) => ({
  minWidth: level === 1 ? 36 : 18,
  padding: 0,
  color: iconSelectedColor,
  ...(!isSideBarOpen &&
    level === 1 && {
      borderRadius: '8px',
      width: 46,
      height: 46,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: activeModule ? '#274F8A' : 'transparent',
      '&:hover': {
        backgroundColor: '#FFFFFF0A',
      },
      ...(activeModule && {
        '&:hover': {
          backgroundColor: '#274F8A',
        },
      }),
    }),
}));

export const StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => !['level', 'isSideBarOpen', 'iconSelectedColor'].includes(prop as string),
})<StyledListItemButtonProps>(({ level, isSideBarOpen, iconSelectedColor }) => ({
  zIndex: 1201,
  borderRadius: '4px',
  margin: '0px 12px',
  padding: !isSideBarOpen ? 0 : 12,
  marginTop: !isSideBarOpen ? 15 : 0,
  minHeight: isSideBarOpen ? '48px' : '40px',
  color: 'white',

  ...(!isSideBarOpen && {
    justifyContent: 'center',
    minWidth: '48px',
    width: '48px',
    margin: '0 auto',

    '.MuiListItemIcon-root': {
      margin: 0,
      minWidth: '24px',
      justifyContent: 'center',
    },
  }),

  '&.MuiListItemButton-root.Mui-selected': {
    backgroundColor: isSideBarOpen ? '#274F8A' : '#274F8A',
  },

  '&.MuiListItemButton-root:hover': {
    backgroundColor: '#274F8A',
  },

  ...(isSideBarOpen &&
    level === 1 && {
      '&.Mui-selected': {
        backgroundColor: '#274F8A',
        color: iconSelectedColor,
      },
    }),
  ...((isSideBarOpen || level !== 1) && {
    py: level === 1 ? 0 : 0,
    '&.Mui-selected': {
      backgroundColor: '#274F8A',
    },
  }),
}));
